import { render, staticRenderFns } from "./WorksheetAdminRegister.vue?vue&type=template&id=1870920b&"
import script from "./WorksheetAdminRegister.vue?vue&type=script&lang=js&"
export * from "./WorksheetAdminRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports